import React, { forwardRef } from 'react';
import { fetchToken, useVisibleSubLayers, scaleToResolution } from '@agissc/ktag-map';
import useAppState from '../../AppStore';

interface PrintVisibleLayersProps {
  url: string;
  topicId: string;
  isPublic: boolean;
  printScale: number;
}

const PrintVisibleLayers = forwardRef<HTMLInputElement, PrintVisibleLayersProps>(
  ({ url, topicId, isPublic, printScale }, ref) => {
    const topicSubLayerSetting = useAppState((state) => state.topicSubLayerSetting);

    const enabledLayerIds = topicSubLayerSetting[topicId]
      ?.filter((subLayer) => subLayer.isEnabled)
      .map((subLayer) => subLayer.id);

    const resolution = scaleToResolution(printScale);

    const visibleLayerIds = useVisibleSubLayers(
      url,
      enabledLayerIds,
      isPublic ? undefined : fetchToken,
      resolution,
    );

    if (visibleLayerIds.isLoading || !visibleLayerIds.data) return null;

    return (
      <input
        ref={ref}
        type="hidden"
        name="visibleLayers"
        value={visibleLayerIds.data.join(',')}
      />
    );
  },
);

export default PrintVisibleLayers;
